import React, { useState, useEffect } from "react";
import localConfig from "../localConfig.json";
import axios from "axios";

function CountyList(props) {
  const [data, setData] = useState({ counties: [] });
  useEffect(() => {
    const fetchData = async () => {
      const result = await axios({
        method: "get",
        url:
          "https://" +
          localConfig.SERVICE.URL +
          ":" +
          localConfig.SERVICE.PORT +
          `/api/dashboard/counties/` +
          props.presenterId + `/null/null`,
          withCredentials: true,
          params: {},
      });
      setData(result.data);
    };
    fetchData();
  }, [props.presenterId]); // vars on which the hook depends

  return (
    <div>
      <h4># of events by county</h4>
      <ul style={{ listStyle: "none" }}>
        {Object.keys(data)
          .map((key) => {
            return data[key];
          })
          .map((item) => (
            <li>
              {item.County} County (<span style={{
                fontWeight:"bold",
                fontSize:"80%"
                }}>{item.Events}</span>)
            </li>
          ))}
      </ul>
    </div>
  );
}

export default CountyList;
